var map = {
	"./beer_big.png": "8c30",
	"./beer_fill - Kopie.png": "cb00",
	"./beer_fill.png": "52ca",
	"./beer_glass_large.png": "e786",
	"./beer_glass_small.png": "fae0",
	"./default_fill.png": "9406",
	"./female.png": "6067",
	"./logo.png": "cf05",
	"./male.png": "8880",
	"./shot_glass.png": "9fe6",
	"./wine_fill - Kopie.png": "eca0",
	"./wine_fill.png": "234c",
	"./wine_glass.png": "3afc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";